import axios from "axios"
import { VERSION } from "../config";
const _MODULE = `/mall/${VERSION}/mobile/order`;
export default {
    /***
     * 获取订单列表
     */
    getOrderList(params) {
        return axios({
            url: `${_MODULE}/page`,
            method:`GET`,
            loading: false,
            params
        })
    },
    /***
     * 获取未支付订单列表
     */
    getNoPayOrderList(params) {
        return axios({
            url: `${_MODULE}/page`,
            method:`GET`,
            loading: false,
            params
        })
    },
    /***
     * 获取待服务订单列表
     */
    getNoServiceOrderList(params) {
        return axios({
            url: `${_MODULE}/page`,
            method:`GET`,
            loading: false,
            params
        })
    },
    /***
     * 获取服务中订单列表
     */
    getServicingOrderList(params) {
        return axios({
            url: `${_MODULE}/page`,
            method:`GET`,
            loading: false,
            params
        })
    },
    /***
     * 获取待评价订单列表
     */
    getNoCommentsOrderList(params) {
        return axios({
            url: `${_MODULE}/page`,
            method:`GET`,
            loading: false,
            params
        })
    },
    /***
     * 获取订单详情页
     */
    getOrderDetail(orderId) {
        return axios({
            url: `${_MODULE}/${orderId}`,
            method:`GET`,
            loading: false
        })
    },
    /***
     * 取消订单详情
     */
    cancelOrder(orderId) {
        return axios({
            url: `${_MODULE}/${orderId}/cancel`,
            method:`PUT`
        })
    },
    /***
     * 评价订单
     */
    evaluateService(data) {
        return axios({
            url: `${_MODULE}/appraisal`,
            method:`POST`,
            data
        })
    },
    
}


// WEBPACK FOOTER //
// ./src/apis/src/orderList.js